import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-qr-code',
  styleUrls: ['./qr-code.component.scss'],
  templateUrl: './qr-code.component.html'
})
export class QrCodeComponent implements OnInit {

  private readonly backendImgUrl: string;
  public imageURL: SafeUrl;

  constructor(private activatedRoute: ActivatedRoute,
              private sanitizer: DomSanitizer,
              private httpClient: HttpClient) {
    const token = activatedRoute.snapshot.params.token;
    this.backendImgUrl = `${environment.backendApiUrl}` + '/v1/qr/' + token;
  }

  ngOnInit(): void {
    this.loadImage().subscribe(blob => {
      this.imageURL = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
    });
  }

  loadImage(): Observable<Blob> {
    return this.httpClient.get(this.backendImgUrl, {responseType: 'blob'});
  }
}
